import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthActions } from "@/components/providers/auth-context";
import { useSiteSelection } from "@/lib/stores/site-store";

/**
 * Sign out and clear every piece of state that could leak between users.
 *
 * Extracted from the dashboard's user menu so the first run can offer the same
 * thing: since `/login` and `/signup` mount one sign-up-or-in flow, a mistyped
 * address lands on the first run with a brand-new empty account, and the greeting
 * that tells them so has to give them a way out (task 212).
 */
export function useSignOut(): () => Promise<void> {
  const { logout } = useAuthActions();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useCallback(async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Logout failed:", error);
    }
    queryClient.clear();
    useSiteSelection.getState().clearSelection();
    navigate("/login");
  }, [logout, navigate, queryClient]);
}
